import React, { useState, useEffect } from 'react';
import { Button, Table, Popconfirm, Space, message } from 'antd';
import SPButton from 'components/carRental/base/SPButton';
import { TablePaginationConfig } from 'antd/lib/table';
import type { TableProps } from 'antd';

import moment from 'moment';

import { IStoreTableDataType, IStoreTablePropsType, IActionBarPropsType } from 'types/carRental';

import request from 'request';

import { API_STORE_LIST } from 'hooks/carRental/_';
import { storeUpdateStatus } from 'hooks/carRental/store';

import emiter, {
  EVENT_CARRENTAL_STORE_EDIT,
  EVENT_CARRENTAL_STORE_VIEW,
  EVENT_CARRENTAL_ADD_STORE,
  EVENT_CARRENTAL_STORE_DAY_OFF,
  EVENT_CARRENTAL_STORE_SEARCH,
  EVENT_CARRENTAL_BRANCH_MODAL_OPEN,
  EVENT_CARRENTAL_OPEN_SERVICESCOPE_MODAL, EVENT_CARRENTAL_VEHICLE_OCCUPYDATE_SEARCH_FROM_SEARCH,
} from '../../../../events';
import EnumKeyToText from "../../../product-price/base/EnumKeyToText";

const SPStoreListActionBar: React.FC<IActionBarPropsType> = props => {
  const { permission } = props;
  const createButtonText = '创建门店';
  const actionBarStyle: React.CSSProperties = { paddingBottom: 12, display: 'flex', justifyContent: 'right' };

  const onCreate = () => {
    emiter.emit(EVENT_CARRENTAL_ADD_STORE);
  };

  return (
    <Space style={actionBarStyle}>
      <SPButton permissionKey="create-store" permission={permission} type="primary" onClick={onCreate}>
        {createButtonText}
      </SPButton>
    </Space>
  );
};

const DEFAULT_PAGE_SIZE = 10;

interface TableActionBarPropsType {
  data?: any;
}

const CreatTimeActionBar = (props: any) => <>{moment(props?.time * 1000).format('YYYY-MM-DD HH:mm:ss')}</>;

const BusinessTimeActionBar = (props: any) => <>{`${props.openTime}-${props.endTime}`}</>;

const StoreStatusActionBar = (props: any) => (
  <>{(props?.storeStatus || []).find((item: any) => item.key === props?.value)?.value}</>
);

const SPStoreListTable: React.FC<IStoreTablePropsType> = props => {
  const { enums, permission } = props;

  const { store_status } = enums || {};
  const [data, setData] = useState<any>([]);
  const [searchData, setSearchData] = useState({});
  const [totalCount, setTotalCount] = useState(0);
  const [currentPageData, setCurrentPageData] = useState<any>({ pageIndex: 1, pageSize: DEFAULT_PAGE_SIZE });

  const SPStoreListTableActionBar: React.FC<TableActionBarPropsType> = props => {
    const { data } = props;

    //从enums删除本身已有状态
    //const newEnums = enums?.filter((item: any) => item.key !== data.packageStatus) || []

    const onEdit = () => {
      emiter.emit(EVENT_CARRENTAL_STORE_EDIT, data);
    };

    const onView = () => {
      emiter.emit(EVENT_CARRENTAL_STORE_VIEW, data);
    };

    const onUpdateStatus = () => {
      storeUpdateStatus({ store_code: data.store_code }).then((res: any) => {
        const { errno } = res || {};
        if (errno === 0) {
          message.success('操作成功');
          loadData(searchData);
        }
      });
    };

    const onRestDay = () => {
      emiter.emit(EVENT_CARRENTAL_STORE_DAY_OFF, data);
    };

    const onBranch = () => {
      emiter.emit(EVENT_CARRENTAL_BRANCH_MODAL_OPEN, data);
    };

    const onService = () => {
      emiter.emit(EVENT_CARRENTAL_OPEN_SERVICESCOPE_MODAL, data);
    };

    return (
      <>
        <SPButton permission={permission} permissionKey="store_update" type="link"  onClick={onEdit}>
          编辑
        </SPButton>
        <SPButton permission={permission} permissionKey="store_detail"  type="link" onClick={onView}>
          查看
        </SPButton>
        <Popconfirm
          title={`确定将门店${data.store_status === 1 ? '下架' : '上架'}吗`}
          okText="确定"
          cancelText="取消"
          onConfirm={onUpdateStatus}
        >
          <SPButton permission={permission} permissionKey="store_update_status"  type="link">{data.store_status === 1 ? '下架' : '上架'}</SPButton>
        </Popconfirm>
        <SPButton type="link" permission={permission} permissionKey="store_rest_schedule_list"  onClick={onRestDay}>
          休息日管理
        </SPButton>
        <SPButton type="link" permission={permission} permissionKey="store_website_list"  onClick={onBranch}>
          网点管理
        </SPButton>
        <SPButton type="link" permission={permission} permissionKey="store_service_area_list"  onClick={onService}>
          服务范围管理
        </SPButton>
      </>
    );
  };

  const columns: TableProps<IStoreTableDataType>['columns'] = [
    { title: '门店城市', dataIndex: 'city_name', width: 150 },
    { title: '门店名称', dataIndex: 'store_name', width: 150 },
    { title: '地址描述', dataIndex: 'address', width: 260 },
    {
      title: '营业时间',
      dataIndex: 'open_time',
      width: 150,
      render: (_, record: any) => <BusinessTimeActionBar openTime={record.open_time} endTime={record.end_time} />,
    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
      width: 120,
      render: creatTime => <CreatTimeActionBar time={creatTime} />,
    },
    {
      title: '审核状态',
      dataIndex: 'audit_status',
      width: 100,
      render: (_, record) => <EnumKeyToText data={record} enums={enums} valueKey={'audit_status'} nameSpace={'audit_status'} />,
    },
    {
      title: '门店状态',
      dataIndex: 'store_status',
      width: 100,
      render: status => <StoreStatusActionBar storeStatus={store_status} value={status} />,
    },
    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      className: 'common-tab-action-bar',
      render: (_, record) => <SPStoreListTableActionBar data={record} />,
    },
  ];

  const loadData = (data?: any) => {
    const { city_id, store_name, store_status, pageIndex = 1, pageSize = DEFAULT_PAGE_SIZE, audit_status = -1 } = data || {};

    setCurrentPageData({ pageIndex, pageSize });
    const params = {
      city_id,
      store_name,
      store_status: store_status && JSON.stringify(store_status),
      page: pageIndex,
      page_size: pageSize,
      audit_status,
    };

    request
      .get(API_STORE_LIST, {
        params,
      })
      .then((res: any) => {
        const { data } = res || {};
        setData(data.list || []);
        setTotalCount(data.total);
        setSearchData(params);
        // setCurrentPageData({pageIndex: data.page || 1, pageSize: data.page_size || 10});
      });
  };

  // TODO: 清空再搜索，翻页有问题
  const onPagination = (pagination: TablePaginationConfig) => {
    setCurrentPageData({
      pageIndex: pagination.current,
      pageSize: pagination.pageSize,
    });
    loadData({ ...searchData, pageIndex: pagination.current, pageSize: pagination.pageSize });
  };

  useEffect(() => {
    loadData({});
  }, []);

  useEffect(() => {
    emiter.on(EVENT_CARRENTAL_STORE_SEARCH, loadData);
    return () => {
      emiter.removeAllListeners(EVENT_CARRENTAL_STORE_SEARCH)
    }
  }, []);

  return (
    <>
      <SPStoreListActionBar permission={permission}   />
      <Table
        size='middle'
        scroll={{ x: '100%' }}
        columns={columns}
        dataSource={data}
        rowKey={cols => cols.store_code}
        pagination={{
          total: totalCount,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: total => `共 ${total} 条数据`,
          current: currentPageData?.pageIndex,
          pageSize: currentPageData?.pageSize,
        }}
        onChange={onPagination}
      />
    </>
  );
};

export default React.memo(SPStoreListTable);
